/** 공유 API 설정 */

export const API_BASE_URL = "/api";

/** 이벤트 버퍼 최대 크기 */
export const MAX_EVENTS = 200;

/**
 * 현장 ID가 녹화영상(playback) 제공 대상인지 확인.
 *
 * 과거에는 일부 현장만 허용하는 하드코딩 목록([15, 17, 18])을 썼으나, 백엔드 playback은
 * NVR 타입(Hikvision/Wisenet) 무관하게 동작하므로 NVR이 연결된 모든 현장에서 활성화한다.
 * (개별 NVR/카메라 접근 실패는 재생 요청 시 에러로 처리)
 */
export function isPlaybackEnabledSite(siteId: number | string | undefined | null): boolean {
  if (siteId == null) return false;
  const id = typeof siteId === "string" ? Number(siteId) : siteId;
  return Number.isFinite(id);
}
